// extracted by mini-css-extract-plugin
export default {"noLogoWrapper":"_5KmQ5"};